import { Col, Row } from '@op/opds.opux';
import { useEffect, useState } from 'react';
import { useMessage, Message } from '@messageformat/react';
import { space } from '@op/opds-tokens';
import { FundItem } from '../interfaces/FundItemInterface';
import FundComponent from './FundComponent';
import AdditionalRecommendation from './AdditionalRecommendation';
import StartStockInvestingInfo from './StartStockInvestingInfo';
import instance from '../instance';
import { ReactComponent as Image1 } from '../images/symbolikuvitus_128_009.svg';
import { ReactComponent as Image2 } from '../images/symbolikuvitus_128_036.svg';
import { ReactComponent as Image3 } from '../images/symbolikuvitus_128_046.svg';

interface Props {
  profitExpectation: number;
  isPersonCustomer: boolean;
}
const RecommendationComponent = (props: Props): JSX.Element => {
  const { profitExpectation, isPersonCustomer } = props;
  const [fundRecommendations, setFundRecommendations] = useState<FundItem[]>();
  const tryOptions = useMessage('additionalRecommendation_tryOptions');
  const bankSaving = useMessage('additionalRecommendation_bankSaving');
  const highProfitExpectation = useMessage(
    'additionalRecommendation_highProfitExpectation',
  );
  const locale = (document.documentElement.lang || 'fi').slice(0, 2);

  const additionalInformation = (): JSX.Element | null => {
    if (profitExpectation === 0 || profitExpectation === 1) {
      return (
        <Row style={{ margin: 0 }}>
          <Col
            lg={4}
            style={{ display: 'flex', paddingLeft: '0px', marginRight: space.small }}
          >
            <AdditionalRecommendation
              message={bankSaving}
              Image={Image2}
              showSavingsLink
            />
          </Col>
          <Col lg={4} style={{ display: 'flex', paddingLeft: '0px' }}>
            <AdditionalRecommendation message={tryOptions} Image={Image1} />
          </Col>
        </Row>
      );
    }
    if (profitExpectation === 10) {
      return (
        <Row style={{ margin: 0 }}>
          <Col lg={4} style={{ display: 'flex', paddingLeft: '0px' }}>
            <AdditionalRecommendation message={highProfitExpectation} Image={Image3} />
          </Col>
          <Col
            lg={8}
            style={{ display: 'flex', paddingLeft: '0px', paddingRight: '0px' }}
          >
            <StartStockInvestingInfo isPersonCustomer={isPersonCustomer} />
          </Col>
        </Row>
      );
    }
    return (
      <Row style={{ margin: 0 }}>
        {fundRecommendations?.map((fundRecommendation, index) => {
          return (
            <Col
              lg={4}
              key={fundRecommendation.name}
              className={`savingscalculator-fundrecommendation-column${index}`}
            >
              <FundComponent
                fundName={fundRecommendation.name}
                profitExpectation={fundRecommendation.profitExpectation}
                riskCategory={fundRecommendation.riskClass}
                responsibility={fundRecommendation.esgInfo}
                fundDescription={fundRecommendation.description}
                isPersonCustomer={isPersonCustomer}
                index={index}
                bonusAccrual={fundRecommendation.bonusAccrual}
              />
            </Col>
          );
        })}
      </Row>
    );
  };

  useEffect(() => {
    const getFundsInformation = async (): Promise<FundItem[] | undefined> => {
      // eslint-disable-next-line max-len
      const fundRecommendationName = `fundrecommendation-${profitExpectation.toString()}-${locale}`;
      const fundsJson = sessionStorage.getItem(fundRecommendationName);
      let fundsList;
      if (
        fundsJson === null &&
        profitExpectation !== 0 &&
        profitExpectation !== 1 &&
        profitExpectation !== 10
      ) {
        fundsList = await instance
          .get('funds', {
            params: {
              profitExpectation,
              locale,
            },
          })
          .then((response: any) => {
            return response.data;
          });
        sessionStorage.setItem(fundRecommendationName, JSON.stringify(fundsList));
      } else if (fundsJson !== null) {
        fundsList = JSON.parse(fundsJson);
      }

      return fundsList;
    };

    const getFunds = async (): Promise<void> => {
      const fundsInformation = getFundsInformation();
      fundsInformation.then((value) => {
        setFundRecommendations(value);
      });
    };

    getFunds();
  }, [locale, profitExpectation]);

  return (
    <>
      <h2
        className="recommendationcomponent-title"
        style={{
          paddingTop: space.large,
          paddingBottom: space.default,
        }}
      >
        <Message id="recommendation_matchingFunds" />
      </h2>

      {additionalInformation()}
    </>
  );
};

export default RecommendationComponent;
